module.exports = __webpack_public_path__ + "img/project.c17cc797.png";